import SwellColor from './color';
import SwellColorSchemeGroup from './color-scheme-group';
import SwellFont from './font';
import SwellLookup from './lookup';
import SwellMenu from './menu';
import SwellUrl from './url';

const dataFetchers = {
  SwellColor,
  SwellColorSchemeGroup,
  SwellFont,
  SwellLookup,
  SwellMenu,
  SwellUrl,
};

// TODO: this function is only used for external widgets
// however all of the above widgets were changed to inline
// because settings are resolved in the canvas instead of the editor
// - Remove this code if we don't need external widgets before production launch
export default function onChangePageData(setPageData, containerProps) {
  return async (externals) => {
    const data = {};

    await Promise.all(
      Object.entries(externals).map(async ([key, ref]) => {
        if (dataFetchers[ref.widgetId]) {
          try {
            const value = await dataFetchers[ref.widgetId](
              ref.id,
              ref.params,
              containerProps,
            );
            data[key] = {
              type: ref.widgetId,
              value,
            };
          } catch (err) {
            data[key] = {
              type: ref.widgetId,
              error: err.message,
            };
          }
        }
      }),
    );

    console.log('onChangePageData', { data, externals });

    setPageData(data);
  };
}
